<template>
  <div>
    <div class="bg-white mb-10">
        <div class="d-flex justify-content-between align-items-center border border-dashed border-gray-300 rounded min-w-750px px-7 py-3">
            <div class="fs-5 text-gray-900 text-hover-primary fw-semibold">
              <div class="fs-5 ">
                <span class="text-gray-800 fw-bold me-1">{{ $t('shop.open_session') }} :</span>
                <span class="text-gray-600 fw-semibold"> {{ sessionForm.opened }}</span>
              </div>
              <div class="fs-5 ">
                <span class="text-gray-800 fw-bold me-1">{{ $t('session.turnover') }} :</span>
                <span class="text-gray-600 fw-semibold"> {{ formattedSalesTurnover }} </span>
              </div>
            </div>

            <div class="pe-2">
              <div class="fs-5 ">
                <span class="text-gray-800 fw-bold me-1">{{ $t('shop.close_session') }} :</span>
                <span class="text-gray-600 fw-semibold"> {{ sessionForm.closed }}</span>
              </div>
              <div class="fs-5 mb-2">
                <span class="text-gray-800 fw-bold me-1">{{ $t('session.box') }} :</span>
                <span class="text-gray-600 fw-semibold">{{ sessionForm.box  }}</span>
              </div>
            </div>

            <div class="pe-2">
              <div class="fs-5 ">
                <span class="text-gray-800 fw-bold me-1">{{ $t('session.start_cash') }} :</span>
                <span class="text-gray-600 fw-semibold"> {{ formattedCashRegister }}</span>
              </div>
              <div class="fs-5">
                <span class="text-gray-800 fw-bold me-1">{{ $t('session.boxer') }} :</span>
                <span class="text-gray-600 fw-semibold"> {{ sessionForm.operator_name }}</span>
              </div>
            </div>
        </div>
    </div>

    <div class="card mb-5 mb-xxl-8">
      <div v-if="isLoading" class="d-flex flex-column-fluid align-items-center justify-content-center h-100">
        <div class="text-center">
          <Loader />
        </div>
      </div>

      <div v-else class="content d-flex flex-column flex-column-fluid" id="kt_content">
        <div id="kt_content_container" class="container-xxl">
          <div class="card ">
            <div class="card-header card-header-stretch">
              <h3 class="card-title">{{['session-sales-path', 'session-details-default'].includes($route.name) ? $t('shop.sale_list') : $t('shop.sale_product')}}</h3>
              <div class="card-toolbar">
                <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                  <li class="nav-item">
                    <router-link class="nav-link text-active-primary"
                       :to="{ name: 'session-sales-path', params: { id: $route.params.id, sessionId: $route.params.sessionId } }"
                       :class="['session-sales-path', 'session-details-default'].includes($route.name) ? 'active' : ''" >
                      {{ $t('session.sales') }}</router-link>

                  </li>
                  <li class="nav-item">
                    <router-link class="nav-link text-active-primary"
                       :to="{ name: 'session-products-path', params: { id: $route.params.id, sessionId: $route.params.sessionId } }"
                       :class="$route.name === 'session-products-path' ? 'active' : ''" > {{ $t('session.products') }}</router-link>

                  </li>
                </ul>
              </div>
            </div>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {BASE_URL} from "@/services/api";
import { mapActions,mapGetters} from 'vuex'
import {getSingleSession} from "@/store/modules/session/actions";
import {Settings} from "luxon";
import Loader from "@/components/Loader.vue";
export default {
  name: "Details",

  components : {
    Loader
  },

  data(){
    return {
      box: '',
      createSession : false,
      formCreateData: {
        cash_register : 0
      },
      showAlert: true,
      sessionForm: {
        cash_register: 0,
        opened: '',
        closed: '',
        shop: '',
        box: '',
        operator_name: '',
        operator_phone: '',
        operator_email: '',
        sales_turnover:0,
        turnover:  0
      },
      session: {},
      title : 'menu.session',
      breadcrumbs: [
      ],
      openedTime: '',
      isLoading: false,
      currency: ''
    }
  },

  watch : {
    currentSession : async function(value){
      this.createSession = value
      if(!value){
        await this.getShopBox()
      }

    },
    '$i18n.locale': function (value) {
      Settings.defaultLocale = value
    },
  },

  computed : {
    ...mapGetters('session',[
      'currentSession',
      'currentShopBox',

    ]),
    ...mapGetters('user',[
      'currentUser'
    ]),
    ...mapGetters('boxes',[
      'getBoxes'
    ]),
    locale() {
      return this.$i18n?.locale;
    },
    formattedSalesTurnover: {
      get() {
        return this.$formatLocalAmount(this.sessionForm.sales_turnover) + " " + (this.currency ?   this.currency  : '');
      },
      set(value) {
        this.sessionForm.sales_turnover = value;
      }
    },
    formattedCurrentCashRegister: {
      get() {
        return this.$formatLocalAmount(this.sessionForm.turnover) + " " + (this.currency ?   this.currency  : '');
      },
      set(value) {
        this.sessionForm.turnover = value;
      }
    },
    formattedCashRegister: {
      get() {
        return this.$formatLocalAmount(this.sessionForm.cash_register) + " " + (this.currency ?   this.currency  : '');
      },
      set(value) {
        this.sessionForm.cash_register = value;
      }
    }
  },

  beforeUnmount() {
    if (this.table) {
      try { this.table.destroy(true) } catch (e) {}
      this.table = null
    }
  },

  async mounted(){

    this.isLoading = true
    this.fetchSessionDatas()
    await this.getSession()
    this.loadBoxes()

    if(!this.currentSession){
      await this.getShopBox()
    }
    if (this.currentSession && this.currentSession.opened ) {
      this.updateTimeLeft()
      setInterval(this.updateTimeLeft, 1000)
    }
    let response = await this.getSingleSession(this.$route.params.sessionId)
    this.session = response.data.session
    this.sessionForm = {
      id: this.$route.params.id,
      cash_register: this.session.cash_register,
      opened: this.$formatToDate(this.session.opened),
      closed: this.$formatToDate(this.session.closed),
      shop: this.session.shop.name,
      box: this.session.box.name,
      operator_name: this.session?.operator.fullname,
      operator_phone: this.session?.operator.phone,
      operator_email: this.session?.operator.email,
      sales_turnover: this.session?.sales_turnover,
      turnover :  parseFloat(this.session.cash_register) + parseFloat(this.session.sales_turnover)
    }

    this.createSession = this.currentSession

    this.isLoading = false

    $(document).on("click", "#kt_datatable_session .session_view_btn", (e) => {
      this.$router.push('/admin/session/details')
    });
    let currencyResponse = await this.getCurrency()
    this.currency = currencyResponse.data.currency_symbol ? currencyResponse.data.currency_symbol : currencyResponse.data.symbol_native
  },

  methods : {
    ...mapActions('session',[
      'getSession',
      'getShopBox',
      'openSession',
      'closeSession',
      'getSingleSession'
    ]),
    ...mapActions('boxes',[
      'loadBoxes'
    ]),
    ...mapActions('shop', ['getCurrency']),

    fetchSessionDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')
      if (this.table) {
        try { this.table.destroy() } catch (e) {}
        this.table = null
      }
      if (!document.getElementById('kt_datatable_session')) return
      this.table = $("#kt_datatable_session").DataTable({
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL+"/get/pos/sessions/datatables",
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data:  function ( d ) {
            console.log( JSON.stringify( d ) ) ;
          }
        },
        columns: [{ data: "opened" },{ data: "closed" },{ data: "box_name" }, { data: "cash_register" },{ data: "operator_name" },{ data: "sales_turnover" }, { data: "Actions", responsivePriority: -1 }],

        columnDefs: [
          {
            targets: -7,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -6,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -5,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -4,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },

          {
            targets: -2,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow'+ l.row +'">' + t + "</span>";
            },
          },


          {
            width: "30%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render=""
              render+='<button type="button" data-id="'+ e.id +'" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto me-5 session_view_btn" >' +
                  '<i  data-id="'+ e.id +'"  class="fa fa-pencil-alt"></i>' +
                  '</button>'
              render+='<button type="button"  class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto delete_btn" title="'+ this.$t('button.delete') +'">' +
                  '<i    class="fa fa-trash-alt"></i>' +
                  '</button> '
              return render
            },
          },

        ],
        language: {
          url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
        }
      });
    },

    async openBox(){
      this.formCreateData.shop_id = this.currentShopBox.shop_id
      this.formCreateData.box_id = this.currentShopBox.box_id

      this.$loading('kt_open_session')
      await this.openSession(this.formCreateData).then((res) => {
        window.toastr.success(this.$t('session.success'))
        this.$stopLoading('kt_open_session')

      }).catch(() => {
        this.$stopLoading('kt_open_session')
      })

    },

    destroyDataTable() {
      if ($.fn.dataTable.isDataTable('#kt_datatable_session')) {

        $('#kt_datatable_session').destroy();
      }
    },

    async closeBox(){
      this.$loading('kt_close_session')
      await this.closeSession().then((res) => {
        window.toastr.success(this.$t('session.danger'))
        this.$stopLoading('kt_close_session')
        this.destroyDataTable()
        this.fetchSessionDatas()
        this.showAlert = false

      }).catch(() => {
        this.$stopLoading('kt_close_session')
      })

    },

    updateTimeLeft() {
      // Récupération de l'heure de la base de données
      let eventTime = new Date(this?.currentSession?.opened)
      let currentTime = new Date()
      let diff = currentTime - eventTime

      let days = Math.floor(diff / (1000 * 60 * 60 * 24))
      let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((diff % (1000 * 60)) / 1000)

      this.openedTime = `${days > 0 ? days + ' : ' : ''} ${hours > 0 ? hours + ' : ' : ''} ${minutes} : ${seconds} `
    }
  }
}
</script>

<style scoped>
input[type="text"] {

  background-color : #eaf6f6;

}
</style>
